import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

const makeStyles = (colors) =>
  StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: colors.lightBg,
      borderRadius: '0.2cm',
      padding: '0.4cm',
      border: `1px solid ${colors.border}`,
      marginBottom: '0.3cm',
      minHeight: '2.5cm',
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    name: {
      fontSize: '11px',
      fontFamily: 'Helvetica-Bold',
      color: colors.darkText,
      marginBottom: '0.1cm',
      textTransform: 'capitalize',
      textAlign: 'left',
    },
    detail: {
      fontSize: '9px',
      fontFamily: 'Helvetica',
      color: colors.bodyText,
      marginBottom: '0.05cm',
      lineHeight: 1.3,
      textTransform: 'capitalize',
      textAlign: 'left',
    },
  });

const SpecialistBlock = (props) => {
  const { specialist } = props;
  const { cargo, especialidad, otros, name } = specialist;
  const { colors } = useTemplateColors();
  const styles = makeStyles(colors);

  return (
    <View style={styles.container}>
      <Text style={styles.name}>{name}</Text>
      {cargo && <Text style={styles.detail}>{cargo}</Text>}
      {especialidad && <Text style={styles.detail}>{especialidad}</Text>}
      {otros && <Text style={styles.detail}>{otros}</Text>}
    </View>
  );
};

export default SpecialistBlock;
